import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Btn } from './UI';

const STORAGE_KEY = 'knowit_cookie_consent';

function saveConsent(value) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...value, savedAt: new Date().toISOString() }));
  window.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: value }));
}

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);

  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      setVisible(true);
      return;
    }

    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed.analytics === 'boolean') {
        setAnalyticsEnabled(parsed.analytics);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const acceptAll = () => {
    saveConsent({ mode: 'accepted', analytics: true });
    setVisible(false);
  };

  const rejectOptional = () => {
    saveConsent({ mode: 'rejected', analytics: false });
    setVisible(false);
  };

  const savePreferences = () => {
    saveConsent({ mode: 'custom', analytics: analyticsEnabled });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: 20,
        right: 20,
        bottom: 20,
        zIndex: 2000,
        background: 'var(--card-bg)',
        border: '1px solid var(--card-border)',
        borderRadius: 12,
        padding: 16,
        boxShadow: '0 8px 28px rgba(0,0,0,0.35)',
      }}
    >
      <p
        style={{
          margin: 0,
          fontFamily: 'var(--font-body)',
          fontSize: '0.9rem',
          color: 'var(--text-secondary)',
          lineHeight: 1.6,
        }}
      >
        We use essential cookies to run this site and optional analytics cookies to improve performance.
        See our <Link to="/cookies" style={{ color: 'var(--cyan)', textDecoration: 'none' }}>Cookie Policy</Link>.
      </p>

      {showPreferences && (
        <div
          style={{
            marginTop: 12,
            padding: 12,
            border: '1px solid var(--card-border)',
            borderRadius: 10,
            background: 'rgba(255,255,255,0.02)',
          }}
        >
          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)',
              fontSize: '0.88rem',
            }}
          >
            <input type="checkbox" checked disabled />
            Essential cookies (always on)
          </label>

          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginTop: 8,
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)',
              fontSize: '0.88rem',
            }}
          >
            <input
              type="checkbox"
              checked={analyticsEnabled}
              onChange={(e) => setAnalyticsEnabled(e.target.checked)}
            />
            Analytics cookies
          </label>
        </div>
      )}

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 14 }}>
        <Btn onClick={acceptAll}>Accept All</Btn>
        <Btn outline onClick={rejectOptional}>Reject Optional</Btn>
        <Btn
          outline
          onClick={() => {
            if (showPreferences) {
              savePreferences();
            } else {
              setShowPreferences(true);
            }
          }}
        >
          {showPreferences ? 'Save Preferences' : 'Preferences'}
        </Btn>
      </div>
    </div>
  );
}
